import React, { useMemo } from 'react';

import Avatar from '@glass/web/components/base/Avatar';
import MuiCardHeader, {
  CardHeaderProps as MuiCardHeaderProps,
} from '@glass/web/components/base/CardHeader';

export type CardHeaderProps = {
  action?: React.ReactNode;
  classes?: MuiCardHeaderProps['classes'];
  elevation?: number;
  subheader?: string;
  avatar?: React.ReactNode;
  title?: string;
  children?: React.ReactNode;
};

const TITLE_TYPOGRAPHY_PROPS = { variant: 'body1' } as MuiCardHeaderProps['titleTypographyProps'];

function CardHeader({
  action,
  classes,
  elevation,
  subheader,
  avatar,
  title = '',
  children,
}: CardHeaderProps) {
  const titleText = title?.[0]?.toUpperCase() || 'R';
  const headerAvatar = useMemo(
    () => avatar ?? (titleText ? <Avatar aria-label="Avatar">{titleText}</Avatar> : undefined),
    [avatar, titleText],
  );

  return (
    <MuiCardHeader
      action={action}
      avatar={headerAvatar}
      classes={classes}
      elevation={elevation}
      subheader={subheader}
      title={title}
      titleTypographyProps={TITLE_TYPOGRAPHY_PROPS}
    >
      {children}
    </MuiCardHeader>
  );
}

export default React.memo(CardHeader);
